import { Box, Theme } from "@mui/material";
import React from "react";
import DotLegalLink from "../../common/components/dotLegalLink/DotLegalLink";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { isNullOrWhitespace } from "@common/stringOperations";

export interface NavigateToProps {
    color: "white" | "darkblue" | "purple";
    to: string;
    text: string;
    onlyText?: boolean;
    allMyPageKey?: string;
    onlyUserSpecific?: boolean;
    // Beside a card's title rather than under its content, so it is centred on the title instead of set apart below.
    inCardHeader?: boolean;
}

// The page linked to keeps its own All/Mine choice, so it is set to the dashboard's before the link is followed.
export function rememberAllMyChoice(allMyPageKey: string | undefined, onlyUserSpecific: boolean | undefined) {
    if (!isNullOrWhitespace(allMyPageKey) && onlyUserSpecific !== undefined) {
        sessionStorage.setItem(allMyPageKey!, onlyUserSpecific.toString());
    }
}

function NavigateTo(props: NavigateToProps) {
    return (
        <Box
            onClick={() => rememberAllMyChoice(props.allMyPageKey, props.onlyUserSpecific)}
            sx={(theme) => ({
                mt: props.inCardHeader ? 0 : 1,
                display: "flex",
                alignSelf: props.inCardHeader ? "center" : "flex-end",
                fontSize: theme.typography.pxToRem(14),
                fontWeight: theme.typography.fontWeightBold,
                color: getColor(theme),
                alignItems: "center",
                "& svg": {
                    fill: getColor(theme),
                },
            })}
        >
            {props.onlyText ? (
                <Box
                    sx={{
                        "&:hover": {
                            textDecoration: "underline",
                        },
                    }}
                >
                    {props.text}
                </Box>
            ) : (
                <DotLegalLink bold to={props.to}>
                    {props.text}
                </DotLegalLink>
            )}

            <KeyboardArrowRightIcon />
        </Box>
    );

    function getColor(theme: Theme) {
        return props.color === "white" ? theme.customPalette.white : props.color === "darkblue" ? theme.palette.primary.dark : theme.palette.primary.main;
    }
}

export default NavigateTo;
